import styled from '@emotion/styled';
import { ReactNode } from 'react';

import Header from './Header';
import NavigationBar from './NavigationBar';
import Sidebar from './Sidebar';

interface Props {
    children: ReactNode;
}

function MainLayout({ children }:Props) {
    return (<Container>
        <Header/>
        <Contents data-scroll-restoration={true}>
            {children}
        </Contents>
        <NavigationBar/>
        <Sidebar/>
    </Container>);
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
    position: relative;
    width: 100%;
    background-color: var(--color-gray2);
`;

const Contents = styled.main`
    flex: 1;
    overflow-y: auto;
    padding-top: 32px;
`;

export default MainLayout;
